import { render, staticRenderFns } from "./UnassignedFacesCover.vue?vue&type=template&id=9eecaa3c&scoped=true"
import script from "./UnassignedFacesCover.vue?vue&type=script&lang=js"
export * from "./UnassignedFacesCover.vue?vue&type=script&lang=js"
import style0 from "./UnassignedFacesCover.vue?vue&type=style&index=0&id=9eecaa3c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9eecaa3c",
  null
  
)

export default component.exports